import { useState } from "react";
import * as Mui from "@mui/material";

const AutoCompleteInput = ({ value, onInput, label, placeholder, options = [], getOptionLabel = (option) => option, loading = false, className, variant = 'light', ...props }) => {
    const [localValue, setLocalValue] = useState(value || null);

    const handleChange = (_, newValue) => {
        setLocalValue(newValue);
        onInput(newValue);
    };

    return (
        <Mui.Autocomplete
            options={options}
            getOptionLabel={getOptionLabel}
            loading={loading}
            value={localValue}
            onChange={handleChange}
            renderInput={(params) => (
                <Mui.TextField
                    {...params}
                    className={`custom-input custom-input-${variant} ${className || ''}`.trim()}
                    variant="filled"
                    label={label}
                    placeholder={placeholder}
                    loading={loading}
                />
            )}
            {...props}
        />
    );
};

export default AutoCompleteInput;
